// extracted by mini-css-extract-plugin
module.exports = {"inheritedProps":"_3KPk_"};